import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { MAIN_DEALERS_GROUP } from 'constants/dealersGroup';
import {
  getDealersGroupName,
  setBannerState,
  shouldShowBanner,
} from 'components/pages/Applications/components/ApplicationsBanner/helpers';

export const useMainDealersGroupBannerPresenter = () => {
  const { id: userId } = useSelector((state) => state.user);
  const { dealer: activeDealer } = useSelector((state) => state.activeDealer);

  const [isVisible, setIsVisible] = useState(false);
  const [groupName, setGroupName] = useState('');

  const BANNER_TIMEOUT = 5;

  const getDealersGroupBanner = useCallback(() => {
    if (!activeDealer?.id || !activeDealer?.dealerGroups?.length) {
      return null;
    }

    return getDealersGroupName(activeDealer.dealerGroups, MAIN_DEALERS_GROUP);
  }, [activeDealer]);

  const handleCloseBanner = useCallback(() => {
    if (groupName) {
      setBannerState(groupName, userId);
      setIsVisible(false);
    }
  }, [groupName]);

  useEffect(() => {
    const currentGroupName = getDealersGroupBanner();
    setGroupName(currentGroupName || '');

    if (!!currentGroupName && shouldShowBanner(currentGroupName, userId, BANNER_TIMEOUT)) {
      setIsVisible(true);
    }
  }, [activeDealer]);

  return {
    getDealersGroupBanner,
    handleCloseBanner,
    isBannerVisible: isVisible,
    currentGroupName: groupName,
  };
};
